import { apiGet } from '../../../utils/api';

function rangeToParams(range) {
  const days = { '7d': 7, '30d': 30, '90d': 90, '12mo': 365 }[range];
  const to = new Date();
  const from = days ? new Date(Date.now() - days * 86400000) : new Date('2000-01-01');
  return { from: from.toISOString(), to: to.toISOString() };
}

export async function fetchNode({ node, range }) {
  const { from, to } = rangeToParams(range);
  const params = new URLSearchParams({ from, to });
  if (node?.type) params.set('node_type', node.type);
  if (node?.id) params.set('node_id', node.id);
  if (node?.name) params.set('node_name', node.name);
  const res = await apiGet(`/management/usage/node?${params.toString()}`);
  if (!res.ok) throw new Error('Failed to load usage');
  return res.json();
}

export async function fetchUser({ userId, range }) {
  const { from, to } = rangeToParams(range);
  const params = new URLSearchParams({ from, to });
  const res = await apiGet(`/management/usage/user/${userId}?${params.toString()}`);
  if (!res.ok) throw new Error('Failed to load user usage');
  return res.json();
}
